import React, { useEffect, useState } from "react";

import { Tooltip } from 'react-tooltip';

import AchievementBadge from "./AchievementBadge";
import Loading from "./utils/Loading";
import Store from "./utils/Store";

import { url } from "../config";
const axios = require("axios").default;

/**
 * Vitrína odznakov jedného kužeľníka - získané farebne, nezískané v šedom s progressom.
 * Používa sa v menu modale (vlastné odznaky) aj v profile kužeľníka (odznaky iných).
 *
 * @param kuzelnikId ak nie je zadané, načítajú sa odznaky prihláseného kužeľníka
 * @param title      meno nad vitrínou; ak nie je zadané, doplní sa z odpovede
 */
export default function AchievementsShowcase({ kuzelnikId = null, title = null, tooltipId = "achievementsShowcaseTooltip" }) {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, [kuzelnikId])

    const loadData = () => {
        setLoading(true);

        //pri vlastnom profile sa použije /my - ten navyše dopočíta časovo podmienené odznaky (veterán)
        let loggedUserId = Store.getObject("loggedUser").id;
        let isMe = kuzelnikId == null || kuzelnikId === loggedUserId;

        axios.get(url + (isMe ? "/private/rest/achievement/my" : `/private/rest/achievement/kuzelnik/${kuzelnikId}`))
            .then(res => {
                setProfile(res.data);
                setLoading(false);
            })
            .catch(err => {
                setProfile(null);
                setLoading(false);
            });
    }

    if (loading) return <Loading marginTop='170px'></Loading>;

    if (!profile) return (
        <div className="d-flex justify-content-center mt-4">
            <i>Odznaky sa nepodarilo načítať</i>
        </div>
    );

    //odznaky prídu v poradí katalógu, zoskupím ich podľa kategórie a poradie zachovám
    let groups = [];
    for (let achievement of profile.achievements ?? []) {
        let group = groups.find(g => g.category === achievement.category);
        if (!group) {
            group = { category: achievement.category, label: achievement.categoryLabel, items: [] };
            groups.push(group);
        }
        group.items.push(achievement);
    }

    let name = title ?? profile.kuzelnik?.nickname ?? profile.kuzelnik?.name;

    return (
        <>
            <div className="achievementsSummary">
                {name && (<div className="achievementsSummaryTitle color-kuzel">{name}</div>)}
                <div className="achievementsSummaryStats">
                    <span><b>{profile.earnedCount}</b> z <b>{profile.totalCount}</b> odznakov</span>
                    <span><b>{profile.kuzelCount}</b> kužeľových udalostí</span>
                    <span><b>{profile.countryCount}</b> krajín</span>
                    <span>najdlhšia séria <b>{profile.longestStreak}</b> dní</span>
                </div>
                <div className="achievementsSummaryNote">Odznaky sa počítajú za Veľkomunitu</div>
            </div>

            {
                groups.map(group => (
                    <div key={group.category} className="achievementsGroup">
                        <div className="achievementsGroupLabel">{group.label}</div>
                        <div className="achievementsGrid">
                            {group.items.map(achievement => (
                                <AchievementBadge key={achievement.code} achievement={achievement} tooltipId={tooltipId} />
                            ))}
                        </div>
                    </div>
                ))
            }

            <Tooltip id={tooltipId} place="top" />
        </>
    );
}
